//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils";

export default {
  data() {
    return {
      supplierInfo: {},
      refreshing: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {},
  activated: function () {},
  methods: {
    requestSuppliers() {
      this.refreshing = true;
      fetch
        .querySupplierInfoById({
          lan: this.languageCode,
          gainSessionSupplierId: "Y",
          queryChildFlag: "Y",
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.supplierInfo = res.data;
            }
          }
          this.refreshing = false;
        });
    },
    onRefresh() {
      this.requestSuppliers();
    },
    back() {
      this.$router.back(-1);
    },
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
  },
  watch: {},
  mounted() {
    this.requestSuppliers();
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/demo/fileRecord.vue